<template>
    <!-- eslint-disable vue/no-custom-modifiers-on-v-model -->
    <vc-date-picker
        v-model.range.string="range"
        :masks="masks"
        :locale="$i18n.locale"
        :min-date="minStartDate"
        :max-date="maxEndDate"
        :columns="$breakpoint.smAndDown ? 1 : 2"
        :rows="1"
        :popover="{placement: 'bottom'}"
        :first-day-of-week="$conf.public.firstDayOfWeek || undefined"
        @dayclick="dayclick"
        @popover-will-show="popoverWillShow"
    >
        <template v-slot="{inputEvents}">
            <div v-on="inputEvents.start">
                <v-text-field
                    :class="textFieldClass"
                    :label="$t('check_in') + ' - ' + $t('check_out')"
                    readonly
                    :single-line="singleLine"
                    :outlined="outlined"
                    variant="outlined"
                    hide-details
                    bg-color="white"
                    :prepend-inner-icon="showIcon ? 'mdi-calendar' : null"
                    :model-value="formattedDate"
                />
            </div>
        </template>
    </vc-date-picker>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {DaterangeM} from '~src/components/search/forms/daterangeM.src'

    @Component({})
    export class ModifyDaterange extends DaterangeM {}

    export default ModifyDaterange
</script>
